<template>
  <question-card @submit="submit" :disabled="buttonDisabled" :buttonText="UIComponentData.Button.Translations[questionnaireLead.Language]">
    <template #title>{{UIComponentData.Header.Translations[questionnaireLead.Language]}}</template>
    <div>
      <v-text-field
        autofocus
        outlined
        :label="UIComponentData.InputPlaceholder1.Translations[questionnaireLead.Language]"
        v-model="questionnaireLead.PhoneNumber"
        @input="$v.questionnaireLead.PhoneNumber.$touch()"
        v-mask="'(###) ###-####'"
        ref="input"
        required
        type="tel"
        inputmode="numeric"
      />
      <div class="communication-policy">
        <div class="communication-policy__container">
          <span>
            {{UIComponentData.Disclaimer.Translations[questionnaireLead.Language][0]}}
            <v-checkbox
            v-model.trim="questionnaireLead.TcpaConsent"
            class="communication-policy__checkbox"
          ></v-checkbox>
          </span>
        </div>
        <span>
          {{UIComponentData.Disclaimer.Translations[questionnaireLead.Language][1]}}
          <tcpa-policy :buttonName="UIComponentData.Disclaimer.Translations[questionnaireLead.Language][2]"> </tcpa-policy>
          {{UIComponentData.Disclaimer.Translations[questionnaireLead.Language][3]}}
        </span>
      </div>
    </div>
  </question-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
import { minLength, required } from 'vuelidate/lib/validators';
import QuestionCard from '@/components/QuestionCard.vue';
import TcpaPolicy from '@/components/TcpaPolicy.vue';

export default {
  name: 'phone-step',
  components: {
    QuestionCard,
    TcpaPolicy,
  },
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
  },
  mixins: [validationMixin],
  validations: {
    questionnaireLead: {
      PhoneNumber: {
        required,
        minLength: minLength(14),
      },
    },
  },
  computed: {
    ...mapGetters(['questionnaireLead']),
    buttonDisabled() {
      return this.$v.$invalid;
    },
  },
  methods: {
    ...mapActions(['mutateLead']),
    submit() {
      if (!this.$v.$invalid) {
        this.questionnaireLead.PhoneNumber=this.questionnaireLead.PhoneNumber.replace(/\D/g, '')
        this.mutateLead(this.questionnaireLead);
        this.$emit('route-to-next-slide',true);
      }
    }
  },
  mounted() {
    this.$refs.input.$el.focus();
  },
};
</script>

<style lang="scss">
@import '~@/styles/variables';

.communication-policy {
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 0px 10px;

  &__checkbox {
      display: inline-block;
      border-radius: 10% !important;
      margin-left: 6px;
      margin-top: 4px !important;
  }

  &__link {
    color: $primary-blue;
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
